<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="32"
    height="28"
    viewBox="0 0 32 28"
  >
    <g :fill="active ? '#00afa1' : '#fff'" fill-rule="evenodd">
      <g>
        <path
          :fill="active ? '#00afa1' : '#fff'"
          d="M0 0H320V4256H0z"
          transform="translate(-21 -210)"
        />
        <g>
          <g transform="translate(-21 -210) translate(11 196)">
            <use
              fill="#000"
              filter="url(#kdtl51buia)"
              xlink:href="#nro1iksz9b"
            />
            <use fill="#00AFA1" xlink:href="#nro1iksz9b" />
          </g>
          <g :fill=" active ? '#FFF' : '#00afa1'" fill-rule="nonzero">
            <g>
              <path
                fill-opacity=".25"
                d="M3.604 10.033C1.617 10.033 0 11.65 0 13.637s1.617 3.604 3.604 3.604 3.604-1.617 3.604-3.604-1.617-3.604-3.604-3.604z"
                transform="translate(-21 -210) translate(11 196) translate(10 14)"
              />
              <path
                d="M17.358 9.49c-.367-.869-.84-1.553-1.358-1.977-.522.427-.997 1.116-1.364 1.99-.396.944-.644 2.035-.73 3.197h4.189c-.088-1.168-.338-2.264-.737-3.21zM13.905 14.575c.088 1.167.338 2.263.737 3.21.367.868.84 1.552 1.358 1.976.522-.426.997-1.116 1.364-1.99.396-.944.644-2.035.73-3.197h-4.189zM9.477 12.7h2.549c.092-1.415.392-2.756.882-3.923.192-.458.41-.88.65-1.26-2.15.861-3.743 2.822-4.08 5.183zM12.027 14.575h-2.55c.339 2.364 1.937 4.328 4.092 5.187-.853-1.352-1.41-3.179-1.542-5.187zM18.431 7.513c.853 1.351 1.41 3.178 1.542 5.187h2.55c-.339-2.365-1.937-4.33-4.092-5.187zM19.974 14.575c-.092 1.415-.392 2.756-.882 3.922-.192.459-.41.88-.65 1.26 2.15-.86 3.743-2.822 4.08-5.182h-2.548z"
                transform="translate(-21 -210) translate(11 196) translate(10 14)"
              />
              <path
                fill-opacity=".25"
                d="M9.407 0C7.42 0 5.803 1.617 5.803 3.604S7.42 7.208 9.407 7.208s3.604-1.617 3.604-3.604S11.394 0 9.407 0zM22.523 0c-1.988 0-3.605 1.617-3.605 3.604s1.617 3.604 3.605 3.604c1.987 0 3.604-1.617 3.604-3.604S24.51 0 22.523 0zM28.396 10.033c-1.987 0-3.604 1.617-3.604 3.604s1.617 3.604 3.604 3.604S32 15.624 32 13.637s-1.617-3.604-3.604-3.604zM22.593 20.066c-1.987 0-3.604 1.617-3.604 3.604s1.617 3.604 3.604 3.604 3.604-1.617 3.604-3.604-1.617-3.604-3.604-3.604zM9.477 20.066c-1.987 0-3.604 1.617-3.604 3.604s1.617 3.604 3.604 3.604c1.988 0 3.604-1.617 3.604-3.604s-1.616-3.604-3.604-3.604z"
                transform="translate(-21 -210) translate(11 196) translate(10 14)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "AboutCompanyIcon",
  props: {
    active: Boolean
  }
}
</script>
